module.exports = __webpack_public_path__ + "static/media/tiger.b6a4c613.jpg";